import Component from '../core/Component';
import throttle from 'lodash/throttle';

export default class Chat extends Component {

    constructor(element) {
        super(element);
        this.getRect();
    }

    require = async function() {
        const TweenLite = await import('TweenLite');
        await import('EasePack');
        return TweenLite
    }

    prepare(TweenLite) {
        window.addEventListener('resize', ::this.getRect);
        const throttledMove = throttle(::this.move);
        this.ref.area.addEventListener('mousemove', throttledMove);

        this.ref.area.addEventListener('mouseleave', ::this.reset);
        this.ref.area.addEventListener('click', event => {
            this.ref.content.querySelector('a').click();
        });
        this.ref.area.addEventListener('mouseover', event => {
            let eventObject = document.createEvent('Events');
            eventObject.initEvent( "mouseover", true, false );
            this.ref.content.querySelector('a').dispatchEvent( eventObject );
        });
    }

    destroy() {
        window.removeEventListener('resize', ::this.getRect)
    }

    move() {
        let x = event.x - this.rect.x - this.rect.width/2
        let y = event.y - this.rect.y - this.rect.height/2

        TweenLite.to(this.ref.content, .4, {
            transform: `translate3d(${x}px, ${y}px, 0)`
        })
    }

    getRect() {
        this.rect = this.element.getBoundingClientRect()
    }

    reset() {
        TweenLite.to(this.ref.content, .8, {
            transform: `translate3d(0, 0, 0)`,
            ease: Back.easeOut.config(1.2)
        })
    }
}


// WEBPACK FOOTER //
// ./components/Magnetic.js